import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stationConnectorSummary: {
    totalStations: 0,
    totalConnectors: 0,
    totalStationsOnboard: 0,
    partners: [],
  },
  loading: false,
  error: null,
};

const GetAllBPROneReducer = createSlice({
  name: "getAllBPROne",
  initialState,

  reducers: {
    fetchBPROneRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchBPROneSuccess: (state, action) => {
      state.loading = false;

      const summary =
        action.payload?.data?.stationConnectorSummary || {};

      state.stationConnectorSummary = {
        totalStations: summary.totalStations || 0,
        totalConnectors: summary.totalConnectors || 0,
        totalStationsOnboard: summary.totalStationsOnboard || 0,
        partners: summary.partners || [],
      };
    },

    fetchBPROneFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchBPROneRequest,
  fetchBPROneSuccess,
  fetchBPROneFailure,
} = GetAllBPROneReducer.actions;

export default GetAllBPROneReducer.reducer;